import { render, staticRenderFns } from "./PlayerFooter.vue?vue&type=template&id=268c9ea7&scoped=true&"
import script from "./PlayerFooter.vue?vue&type=script&lang=js&"
export * from "./PlayerFooter.vue?vue&type=script&lang=js&"
import style0 from "./PlayerFooter.vue?vue&type=style&index=0&id=268c9ea7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268c9ea7",
  null
  
)

export default component.exports